export const ROWS = 20;
export const COLS = 79;
export const MAX_BOARDS = 50;
export const MAX_FILE_BYTES = 1024 * 1024;
export const MAX_TEXT_FILE_BYTES = 2 * 1024;

// Import is data-only. Keep the original printable ASCII decoration characters.
export function normalizeBoard(board, index = 0) {
    const label = `Board ${index + 1}`;
    if (!board || typeof board !== 'object' || Array.isArray(board)) throw new Error(`${label}: expected a board object.`);
    if (typeof board.name !== 'string' || !board.name.trim() || board.name.trim().length > 60) {
        throw new Error(`${label}: give the board a name of 1–60 characters.`);
    }
    if (!Array.isArray(board.layout) || board.layout.length < 1 || board.layout.length > ROWS) {
        throw new Error(`${label}: the map must have 1–${ROWS} rows.`);
    }
    const layout = board.layout.map((row, y) => {
        if (typeof row !== 'string' || row.length > COLS || /[^\x20-\x7e]/.test(row)) {
            throw new Error(`${label}, row ${y + 1}: use at most ${COLS} printable ASCII characters (no tabs).`);
        }
        return row.padEnd(COLS, ' ');
    });
    while (layout.length < ROWS) layout.push(' '.repeat(COLS));
    const text = layout.join('');
    if ([...text].filter(char => char === 'p').length !== 1) throw new Error(`${label}: place exactly one player start (p).`);
    if (!text.includes('$')) throw new Error(`${label}: place at least one treasure ($) to finish the board.`);
    return { name: board.name.trim(), layout };
}

export function normalizePack(value) {
    let boards;
    if (Array.isArray(value)) boards = value;
    else if (value && value.format === 'ladderjs-board-pack') {
        if (value.version !== 1) throw new Error('Unsupported board-pack version. Expected version 1.');
        boards = value.boards;
    } else if (value && Array.isArray(value.layout)) boards = [value];
    if (!Array.isArray(boards) || boards.length < 1 || boards.length > MAX_BOARDS) {
        throw new Error(`Choose a board, an original levels.json array, or a pack containing 1–${MAX_BOARDS} boards.`);
    }
    return boards.map(normalizeBoard);
}

export function parsePack(text) {
    if (new TextEncoder().encode(text).length > MAX_FILE_BYTES) throw new Error('The file is too large. Maximum size is 1 MB.');
    let data;
    try { data = JSON.parse(text); } catch { throw new Error('This is not valid JSON. Choose an exported board pack or levels.json.'); }
    return normalizePack(data);
}

export function parseTextBoard(text, filename = 'Imported board.txt') {
    if (new TextEncoder().encode(text).length > MAX_TEXT_FILE_BYTES) throw new Error('The text board file is too large. Maximum size is 2 KB (2,048 bytes).');
    // A BOM and line endings belong to the text file, not to the board grid.
    // Remove only the final line terminator; never trim meaningful map spaces.
    const map = text.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n').replace(/\n$/, '');
    const name = filename.replace(/\.txt$/i, '').trim().slice(0, 60) || 'Imported board';
    return normalizeBoard({ name, layout: map.split('\n') });
}

export function serializePack(boards) {
    return JSON.stringify({ format: 'ladderjs-board-pack', version: 1, boards: normalizePack(boards) }, null, 2) + '\n';
}

export function newBoard(name = 'My first board') {
    const layout = Array.from({ length: ROWS }, () => ' '.repeat(COLS));
    layout[18] = '  p' + ' '.repeat(69) + '$' + ' '.repeat(6);
    layout[19] = '='.repeat(COLS);
    return { name, layout };
}

export function moveBoard(boards, from, to) {
    if (from < 0 || from >= boards.length || to < 0 || to >= boards.length) return boards;
    const result = [...boards];
    result.splice(to, 0, result.splice(from, 1)[0]);
    return result;
}
